const SAFE_CODES=new Set([
  "invalid_finalization","invalid_practice_result","invalid_question_position",
  "practice_session_completed","practice_session_conflict","study_buddy_practice_unavailable",
]);
const TEMPORARY_STATUSES=new Set([429,500,502,503,504]);

export const MAX_DETERMINISTIC_FINALIZATION_FAILURES=3;

export function classifyStudyBuddyFinalizationError(error){
  const status=Number(error?.response?.status)||null;
  const data=error?.response?.data?.data||error?.response?.data||{};
  const candidate=[data.error_code,data.error,data.code].find((value)=>typeof value==="string")||"";
  const safeCode=SAFE_CODES.has(candidate)?candidate:null;
  if(status===401||["public_session_required","missing_public_session","invalid_public_session","public_session_expired"].includes(candidate))return {kind:"authentication",status,safeCode};
  if(status===400||status===422)return {kind:"deterministic",status,safeCode};
  if(status===403||status===404)return {kind:"unavailable",status,safeCode};
  if(status===409)return {kind:"conflict",status,safeCode};
  if(TEMPORARY_STATUSES.has(status))return {kind:"temporary",status,safeCode};
  if(!error?.response)return {kind:"network",status:null,safeCode:null};
  return {kind:"unknown",status,safeCode};
}

export function correctiveFinalizationResult(safeCode){
  return {
    ok:false,
    error:safeCode||"invalid_finalization",
    retryable:true,
    advance:false,
    instruction:"Correct the tool arguments for the current question and call the finalization tool again. Do not ask the student another question and do not advance.",
  };
}

export function finalizationFailureMessage(kind){
  if(kind==="deterministic")return "Study Buddy could not save this answer result. It will try to correct the result without moving to the next question.";
  if(kind==="unavailable")return "This practice session is no longer available. Return to Study Buddy to start another session.";
  if(kind==="conflict")return "This practice session changed before the answer could be saved. Restore the same session to continue from its current question.";
  if(kind==="temporary"||kind==="network")return "Study Buddy could not save this answer because of a temporary connection problem.";
  return "Study Buddy could not save this answer result. Restore this practice session to continue safely.";
}
